(() => {
  const root = document.querySelector('[data-mxw-home]');
  if (!root) return;

  const dragThreshold = 8;
  const nonDraggableTargetsSelector = 'button, input, select, textarea, summary, label';

  const menuButton = root.querySelector('[data-mxw-menu-button]');
  const mobileMenu = root.querySelector('[data-mxw-mobile-menu]');

  menuButton?.addEventListener('click', () => {
    const willOpen = menuButton.getAttribute('aria-expanded') !== 'true';
    menuButton.setAttribute('aria-expanded', String(willOpen));
    if (mobileMenu) mobileMenu.hidden = !willOpen;
  });

  document.addEventListener('click', (event) => {
    if (menuButton?.getAttribute('aria-expanded') !== 'true') return;
    if (!(event.target instanceof Node)) return;
    if (menuButton.contains(event.target) || mobileMenu?.contains(event.target)) return;

    menuButton.setAttribute('aria-expanded', 'false');
    if (mobileMenu) mobileMenu.hidden = true;
  });

  root.querySelectorAll('[data-mxw-scroll-row]').forEach((row) => {
    let dragState = null;

    row.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary || event.button !== 0) return;
      if (!(event.target instanceof Element)) return;
      if (event.target.closest(nonDraggableTargetsSelector)) return;

      dragState = {
        pointerId: event.pointerId,
        originX: event.clientX,
        originY: event.clientY,
        originScrollLeft: row.scrollLeft,
        isDragging: false,
      };
    });

    row.addEventListener('pointermove', (event) => {
      if (!dragState || event.pointerId !== dragState.pointerId) return;

      const deltaX = event.clientX - dragState.originX;
      const deltaY = event.clientY - dragState.originY;

      if (!dragState.isDragging) {
        if (Math.abs(deltaX) < dragThreshold && Math.abs(deltaY) < dragThreshold) return;
        if (Math.abs(deltaY) > Math.abs(deltaX)) {
          dragState = null;
          return;
        }

        dragState.isDragging = true;
        row.classList.add('is-dragging');
        row.setPointerCapture(event.pointerId);
      }

      event.preventDefault();
      row.scrollLeft = dragState.originScrollLeft - deltaX;
    });

    const endDrag = (event) => {
      if (!dragState || event.pointerId !== dragState.pointerId) return;

      const shouldSuppressClick = dragState.isDragging;

      if (dragState.isDragging) {
        row.classList.remove('is-dragging');
      }

      if (row.hasPointerCapture(event.pointerId)) {
        row.releasePointerCapture(event.pointerId);
      }

      dragState = null;

      if (shouldSuppressClick) {
        row.dataset.mxwSuppressClick = 'true';
        window.setTimeout(() => {
          row.removeAttribute('data-mxw-suppress-click');
        }, 0);
      }
    };

    row.addEventListener('pointerup', endDrag);
    row.addEventListener('pointercancel', endDrag);
    row.addEventListener('lostpointercapture', endDrag);
    row.addEventListener(
      'click',
      (event) => {
        if (row.dataset.mxwSuppressClick === 'true') {
          row.removeAttribute('data-mxw-suppress-click');
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
    row.addEventListener('dragstart', (event) => {
      if (dragState) {
        event.preventDefault();
      }
    });
  });

  const compare = root.querySelector('[data-mxw-compare]');
  if (!compare) return;

  const range = compare.querySelector('[data-mxw-compare-range]');
  let activeComparePointerId = null;

  const setCompareValue = (value) => {
    const percentage = Math.min(100, Math.max(0, value));
    compare.style.setProperty('--mxw-compare', `${percentage}%`);
    if (range) range.value = String(percentage);
  };

  const valueFromPointer = (event) => {
    const rect = compare.getBoundingClientRect();
    return ((event.clientX - rect.left) / rect.width) * 100;
  };

  range?.addEventListener('input', (event) => {
    setCompareValue(Number(event.currentTarget.value));
  });

  compare.addEventListener('pointerenter', (event) => {
    if (event.pointerType === 'mouse') setCompareValue(valueFromPointer(event));
  });

  compare.addEventListener('pointerdown', (event) => {
    activeComparePointerId = event.pointerId;
    compare.setPointerCapture(event.pointerId);
    setCompareValue(valueFromPointer(event));
  });

  compare.addEventListener('pointermove', (event) => {
    if (event.pointerType !== 'mouse' && event.pointerId !== activeComparePointerId) return;
    setCompareValue(valueFromPointer(event));
  });

  compare.addEventListener('pointerup', (event) => {
    if (event.pointerId === activeComparePointerId) activeComparePointerId = null;
  });

  compare.addEventListener('pointercancel', (event) => {
    if (event.pointerId === activeComparePointerId) activeComparePointerId = null;
  });
})();
